// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24edH","content":"styles_content__2ci0M"};